import $i18n from '@alife/panda-i18n';
import React from 'react';
import './index.scss';
import ReplyItem from './reply-item';
import StopButton from '../stop-button';
import { RECORD_STATUS } from '../../hooks/use-record';

const QuickReplies = (props) => {
  const {
    dataSource = [],
    loading,
    recording,
    onStopRecord,
    showStopAnswer,
    onStop,
    onClick,

    recordStatus,
    stopRecord,
    pauseRecord,
    continueRecord,
  } = props;

  return (
    <div className="chatai-ui-reply-wrapper">
      <div className="float">
        {loading && showStopAnswer ? <StopButton className="btn" onClick={onStop} /> : null}
        {recording ? (
          <StopButton
            className="btn"
            style={{ width: 104 }}
            text={$i18n.get({ id: 'TranslatedToText', dm: '转译为文字' })}
            onClick={onStopRecord}
          />
        ) : null}
        {recordStatus === RECORD_STATUS.RECORDING ? (
          <StopButton
            className="btn"
            text={$i18n.get({ id: 'Pause', dm: '暂停' })}
            icon="pause-fill"
            onClick={() => {
              pauseRecord();
            }}
          />
        ) : null}
        {recordStatus === RECORD_STATUS.PAUSED ? (
          <StopButton
            className="btn"
            text={$i18n.get({ id: 'Continue', dm: '继续' })}
            icon="play-r"
            onClick={() => {
              continueRecord();
            }}
          />
        ) : null}
        {recordStatus === RECORD_STATUS.RECORDING || recordStatus === RECORD_STATUS.PAUSED ? (
          <StopButton
            className="btn"
            text={$i18n.get({ id: 'Stop', dm: '停止' })}
            onClick={() => {
              stopRecord();
            }}
          />
        ) : null}
      </div>
      {dataSource.length ? (
        <div className="quickReplies">
          {dataSource.map((item) => (
            <ReplyItem item={item} onClick={onClick} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default QuickReplies;
